import type { ApplicationStatus, HiringStage } from "../types";

export type ApplicationDisplayStatus = ApplicationStatus | "hired";

export function isHiredApplication(application: { stage: HiringStage }): boolean {
  return application.stage === "hired";
}

export function getApplicationDisplayStatus(application: {
  status: ApplicationStatus;
  stage: HiringStage;
}): ApplicationDisplayStatus {
  return isHiredApplication(application) ? "hired" : application.status;
}
